import { useTranslation } from 'react-i18next';
import { Button } from '@et/ui';
import type { Consent } from '../../lib/consent.js';

/**
 * O pedido de consentimento para os cookies de medição.
 *
 * **As duas respostas têm o mesmo peso.** Recusar é um botão a par de
 * aceitar, com a mesma forma e o mesmo tamanho — e não uma ligação cinzenta
 * ao canto. A lei da UE exige-o, mas mesmo que não exigisse: um produto que
 * pede a quem o lê para desconfiar das suas fontes não pode empurrar a
 * resposta que lhe convém no único sítio onde pergunta algo.
 *
 * Não prende o foco nem tapa a página. Não é uma decisão que tenha de ser
 * tomada para se ler o arquivo — e enquanto não for tomada, nada é medido, o
 * que é o comportamento correcto de qualquer maneira.
 */
export function ConsentBanner({ onChoose }: { readonly onChoose: (c: Consent) => void }) {
  const { t } = useTranslation();
  return (
    <div className="et-consent" role="dialog" aria-labelledby="et-consent-title">
      <div className="et-consent__body">
        <h2 className="et-consent__title" id="et-consent-title">{t('consent.title')}</h2>
        <p className="et-consent__text">{t('consent.body')}</p>
      </div>
      <div className="et-consent__actions">
        {/* A mesma variante nos dois, e nao `primary` num e `ghost` no outro:
            escrever que tem o mesmo peso e depois dar mais destaque a um e o
            padrao escuro de sempre, so que com um comentario a negar. */}
        <Button size="sm" variant="ghost" onClick={() => onChoose('granted')}>{t('consent.accept')}</Button>
        <Button size="sm" variant="ghost" onClick={() => onChoose('denied')}>{t('consent.decline')}</Button>
      </div>
    </div>
  );
}
